import * as _ from 'lodash';
import { IFieldValidator } from 'src/app/interfaces/field-settings.interface';
import { IFieldValidationParams } from 'src/app/interfaces/zc-validation-result.interface';
import IAllowedUse = ZoneIQCalibration.IAllowedUse;

export class AllowedUseValidator implements IFieldValidator {
    propertyName: string = null;

    constructor() {}

    validate(params: IFieldValidationParams): string {
        if (this.isValid(params)) {
            return null;
        }

        return this.isValid(params) ? null : 'Allowed Use in not registered in Zoning Code';
    }

    private isValid(params: IFieldValidationParams): boolean {
        const allowedUse = _.get(params.model, 'allowedUse') as IAllowedUse;

        return allowedUse
            ? allowedUse?.importValidationResult
                ? allowedUse?.importValidationResult.isValid
                : true
            : false;
    }
}
